import { render, staticRenderFns } from "./AccessBtn.vue?vue&type=template&id=4c543a54&scoped=true&"
import script from "./AccessBtn.vue?vue&type=script&lang=ts&"
export * from "./AccessBtn.vue?vue&type=script&lang=ts&"
import style0 from "./AccessBtn.vue?vue&type=style&index=0&id=4c543a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c543a54",
  null
  
)

export default component.exports